'use client';

import MagicJump from '@/components/MagicJump';
import { font } from '@/theme/zeelool.theme';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './common.module.scss';
import { useInViewportAnimation } from '@/hooks/useInViewportAnimation'; // 导入动画hook
interface Part3Item {
  img: string;
  title: string;
  desc: string;
  jump_target?: any;
}

interface Part3Data {
  title: string;
  content: string;
  list: Part3Item[];
}

interface Part3Props {
  data: Part3Data | null;
  isMobile: boolean;
}

export default function Part3({ data, isMobile }: Part3Props) {
  // 动画hook，仅PC端执行
  const animationRef = useInViewportAnimation(
    () => {
      if (isMobile) return;
      try {
        const PartArr = [
          '.fit-guide-container-section-part3-title',
          '.fit-guide-container-section-part3-desc',
        ];
        // 标题动画
        PartArr.forEach((item) => {
          const element = document.querySelector(item);
          if (element) {
            element.classList.add('fadeInDownAnimate');
          }
        });
        // 卡片动画
        const cards = document.getElementsByClassName(
          'fit-guide-container-section-part3-swiper-item',
        );
        Array.from(cards).forEach((item, idx) => {
          setTimeout(() => {
            item.classList.add('activityFadeInUpAnimate');
          }, idx * 120);
        });
      } catch {
        // 出错时直接显示
        const elements = document.querySelectorAll('.opacity0');
        elements.forEach((el) => {
          const element = el as HTMLElement; // 创建一个新的变量
          element.style.opacity = '1'; // 修改新变量的属性
        });
      }
    },
    { threshold: 0.3, once: true },
  );
  if (!data || !data.list?.length) {
    return null;
  }
  return (
    <div className="bg-white pt-[40px] pb-[40px] md:pt-[2.92vw] md:pr-[2.45vw] md:pb-[3.59vw] md:pl-[2.45vw]">
      <h2
        className={`fit-guide-container-section-part3-title px-[28px] md:px-0 ${styles.section_title} ${styles['max-line-1']} ${!isMobile ? 'opacity0' : ''}`}
        dangerouslySetInnerHTML={{ __html: data.title }}
      />
      <div
        className={`fit-guide-container-section-part3-desc px-[28px] md:px-0 ${styles.section_desc} ${isMobile ? styles['max-line-3'] : styles['max-line-1']} ${!isMobile ? 'opacity0' : ''}`}
        dangerouslySetInnerHTML={{ __html: data.content }}
      />

      {isMobile ? (
        // 移动端轮播
        <div className="mt-[24px]">
          <Swiper spaceBetween={10} slidesPerView="auto" className="!pl-[14px]">
            {data.list.map((item, index) => (
              <SwiperSlide key={index} className="!w-[166px] mr-[10px]">
                <MagicJump prefetch={false} item={item.jump_target} className="block no-underline">
                  <img
                    className="block w-full h-auto aspect-square rounded-[10px] md:rounded-[20px]"
                    src={item.img}
                    alt={item.title}
                  />
                  <div>
                    <h4
                      className={`text-[16px] leading-[20px] my-[12px] mb-[10px] ${styles['max-line-1']}`}
                      style={{ fontFamily: 'var(--font-bricolage-bold)' }}
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                    <div
                      className={`text-[12px] leading-[18px] min-h-[54px] ${styles['max-line-3']}`}
                      style={{ fontFamily: 'BricolageGrotesque' }}
                      dangerouslySetInnerHTML={{ __html: item.desc }}
                    />
                  </div>
                </MagicJump>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        // PC端网格布局
        <div
          className="mt-[2.08vw] grid grid-cols-5 gap-[2.5vw]"
          ref={(node) => {
            // 为动画设置ref（仅PC端）
            if (!isMobile && animationRef && typeof animationRef !== 'function') {
              (animationRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
            }
          }}
        >
          {data.list.map((item, index) => (
            <div key={index} className="fit-guide-container-section-part3-swiper-item opacity0">
              <MagicJump prefetch={false} item={item.jump_target} className="block no-underline">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-auto aspect-square block rounded-[10px] md:rounded-[20px]"
                />
                <h4
                  className={`mt-[1.04vw] text-base md:text-[1.25vw] leading-6 md:leading-[1.46vw] font-bold" ${styles['max-line-1']}`}
                  style={{ fontFamily: font.bb }}
                  dangerouslySetInnerHTML={{ __html: item.title }}
                />
                <div
                  className={`text-sm md:text-[max(0.83vw,14px)] leading-6 md:leading-[max(1.25vw,14px)] mt-3 md:mt-[0.625vw] h-12 md:h-[2.5vw] ${styles['max-line-2']}`}
                  style={{
                    fontFamily: 'BricolageGrotesque',
                    cursor: item.jump_target?.jump_type ? 'pointer' : 'default',
                  }}
                  dangerouslySetInnerHTML={{ __html: item.desc }}
                />
              </MagicJump>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
